import type { SocialNetwork } from "@/lib/api/types";

export const site = {
  name: "Sweet",
  domain: "sweet.xxx",
  /** The name with its domain, as people search for it ("sweet xxx"): in page titles and the site's structured data. */
  brand: "Sweet.xxx",
  /** Other ways people write it (WebSite and Organization alternateName). */
  brandAlternates: ["Sweet.xxx", "Sweet XXX", "SweetXXX", "Sweet Porn"],
  url: "https://sweet.xxx",
  description:
    "Sweet — free HD adult videos from the best creators and studios, updated every day.",
  supportEmail: "support@sweet.xxx",
  copyrightYear: 2026,
  // RTA label (https://www.rtalabel.org) — lets parental-control filters block the site.
  rtaLabel: "RTA-5042-1996-1400-1577-RTA",
  /**
   * Ad networks' tags, written straight into every page's <head> by the root layout (Next streams a
   * dynamic page's metadata after the head, where some checkers don't look).
   */
  headMeta: [
    // ExoClick (publisher account, site sweet.xxx): ownership, and the browser details its ad server
    // (s.magsrv.com) may ask for to pick the ad, as ExoClick's setup gives them.
    { name: "6a97888e-site-verification", content: "b04f82e55e35a2afd1ce2cc8c768e034" },
    // AnyCash (anycash.com, the AnyPorn network's webmaster program): the site is ours. Its file is in public/ too.
    { name: "anycash", content: "7e23bb8e0938b1c8" },
    // YLMCash (ylmcash.com, AnySex's and YourLust's webmaster program): the same, its file in public/ too.
    { name: "ylmcash", content: "0738f99da4786896" },
    { httpEquiv: "Delegate-CH", content: "Sec-CH-UA https://s.magsrv.com; Sec-CH-UA-Mobile https://s.magsrv.com; Sec-CH-UA-Arch https://s.magsrv.com; Sec-CH-UA-Model https://s.magsrv.com; Sec-CH-UA-Platform https://s.magsrv.com; Sec-CH-UA-Platform-Version https://s.magsrv.com; Sec-CH-UA-Bitness https://s.magsrv.com; Sec-CH-UA-Full-Version-List https://s.magsrv.com; Sec-CH-UA-Full-Version https://s.magsrv.com;" },
  ] as { name?: string; httpEquiv?: string; content: string }[],
} as const;

/**
 * The site's own pages linked from the footer, the menu and the legal pages: `label` in English, `key` its name
 * in the page's language (lib/locales ui footer; footerLabel). 2257 is the same everywhere.
 */
export const footerLinks = [
  { href: "/copyright", label: "Copyright", key: "copyright" },
  { href: "/takedown", label: "Takedown", key: "takedown" },
  { href: "/contact", label: "Contact", key: "contact" },
  { href: "/creators", label: "Creators", key: "creators" },
  { href: "/claim", label: "Claim your profile", key: "claim" },
  { href: "/webmasters", label: "Webmasters", key: "webmasters" },
  { href: "/terms", label: "Terms", key: "terms" },
  { href: "/privacy", label: "Privacy", key: "privacy" },
  { href: "/2257", label: "2257", key: null },
] as const;

/** A footer link's name in the page's language (`footer`: lib/locales ui footer). */
export const footerLabel = (link: (typeof footerLinks)[number], footer: Record<NonNullable<(typeof footerLinks)[number]["key"]>, string>) =>
  link.key ? footer[link.key] : link.label;

/**
 * The picture a link to the site shows when shared (X, Telegram, Reddit…), for pages without one of their
 * own (a video's is its thumbnail): the logo and what the site is, 1200×630.
 */
export const shareImage = { url: "/brand/og.jpg", width: 1200, height: 630, alt: "Sweet — Free Porn Videos & Live Cams" };

/**
 * Sweet's own accounts elsewhere, shown as icons in every page's footer and named in the site's structured
 * data (sameAs) so search engines tie them to the site. The Telegram channel is set in Admin → Settings.
 */
export const siteSocials: { network: SocialNetwork; url: string }[] = [
  { network: "instagram", url: "https://www.instagram.com/sweetcocconuts/" },
  { network: "x", url: "https://x.com/sweetcocconuts" },
  { network: "threads", url: "https://www.threads.com/@sweetcocconuts" },
  { network: "bluesky", url: "https://bsky.app/profile/sweetcocconut.bsky.social" },
  { network: "reddit", url: "https://www.reddit.com/user/sweetcocconut" },
];

